
import { Button } from '@/components/ui/button';
import { Plus, Minus } from 'lucide-react';
import { AdjustmentType } from '../../hooks/useStockAdjustment';

interface AdjustmentTypeSelectorProps {
  adjustmentType: AdjustmentType;
  setAdjustmentType: (type: AdjustmentType) => void;
}

const AdjustmentTypeSelector = ({ 
  adjustmentType, 
  setAdjustmentType 
}: AdjustmentTypeSelectorProps) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <Button
        type="button"
        variant={adjustmentType === 'add' ? 'default' : 'outline'}
        className={adjustmentType === 'add' ? "reference-table-add-button w-full" : "reference-table-action-button w-full"}
        onClick={() => setAdjustmentType('add')}
      >
        <Plus className="mr-2 h-4 w-4" />
        Add Stock
      </Button>
      <Button
        type="button"
        variant={adjustmentType === 'remove' ? 'default' : 'outline'}
        className={adjustmentType === 'remove' ? "reference-table-delete-button w-full" : "reference-table-action-button w-full"}
        onClick={() => setAdjustmentType('remove')}
      >
        <Minus className="mr-2 h-4 w-4" />
        Remove Stock
      </Button>
    </div>
  );
};

export default AdjustmentTypeSelector;
